var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "com-Breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: ">" } },
            [
              _c("el-breadcrumb-item", [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        return _vm.gback()
                      }
                    }
                  },
                  [_vm._v("模板管理")]
                )
              ]),
              _c("el-breadcrumb-item", [_vm._v("新增模板")])
            ],
            1
          ),
          _c(
            "a",
            {
              staticClass: "r-btn",
              on: {
                click: function($event) {
                  return _vm.gback()
                }
              }
            },
            [_vm._v("返回上一步")]
          )
        ],
        1
      ),
      _c(
        "el-container",
        { staticClass: "general" },
        [
          _c(
            "el-main",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingTpl,
                  expression: "loadingTpl"
                }
              ],
              staticClass: "main"
            },
            [
              _c("tpl-editor", {
                ref: "tplEditor",
                attrs: {
                  "insert-html": _vm.innerString,
                  "change-placeholder": _vm.valChange,
                  "del-placeholder": _vm.delInner,
                  "select-placeholder": _vm.currentOpVar.varName || ""
                },
                on: {
                  editorReadyCallback: _vm.handleEditorReadyCallback,
                  change: _vm.handleChange,
                  doubleclickPlaceholder: _vm.handeDoubleclickPlaceholder,
                  clickPlaceholder: _vm.handleClickPlaceholder
                }
              })
            ],
            1
          ),
          _c(
            "el-aside",
            { staticClass: "aside", attrs: { width: "260px" } },
            [
              _c("h4", [_vm._v("模板信息")]),
              _c(
                "el-form",
                {
                  ref: "tplFrm",
                  staticClass: "tpl-info",
                  attrs: {
                    model: _vm.tplFrm,
                    rules: _vm.tplFrmRules,
                    size: "small"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "模板名称", prop: "tplName" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "模板名称", maxlength: "30" },
                        model: {
                          value: _vm.tplFrm.tplName,
                          callback: function($$v) {
                            _vm.$set(_vm.tplFrm, "tplName", $$v)
                          },
                          expression: "tplFrm.tplName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _vm._v("\n            使用范围：\n            "),
                      _c(
                        "el-button",
                        {
                          staticStyle: { width: "80px", "margin-left": "18px" },
                          attrs: { size: "mini" },
                          on: {
                            click: function($event) {
                              return _vm.setCheckedNodes()
                            }
                          }
                        },
                        [_vm._v("选择 >")]
                      ),
                      _c(
                        "ul",
                        { staticClass: "checkedNode" },
                        _vm._l(_vm.defaultChooseList, function(item) {
                          return _c("li", { key: item.corpUserId }, [
                            _c(
                              "a",
                              {
                                staticClass: "span1",
                                attrs: { title: item.userName }
                              },
                              [_vm._v(_vm._s(item.userName))]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "span2",
                                on: {
                                  click: function($event) {
                                    return _vm.deleteSelect(item.corpUserId)
                                  }
                                }
                              },
                              [_vm._v("x")]
                            )
                          ])
                        }),
                        0
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn",
                          on: {
                            click: function($event) {
                              return _vm.toShowEditTplVarDialog(false)
                            }
                          }
                        },
                        [_vm._v("添加变量")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "draggable",
                    {
                      attrs: { list: _vm.tplVarList },
                      on: {
                        start: function($event) {
                          _vm.dragging = true
                        },
                        end: function($event) {
                          _vm.dragging = false
                        }
                      }
                    },
                    [
                      _vm.tplVarList.length
                        ? _vm._l(_vm.tplVarList, function(item, i) {
                            return _c(
                              "div",
                              { key: i, staticClass: "val-item" },
                              [
                                _c(
                                  "p",
                                  {
                                    key: i,
                                    class:
                                      _vm.currentOpVar.varName == item.varName
                                        ? "active"
                                        : "",
                                    on: {
                                      click: function($event) {
                                        return _vm.selectCurrentOpVar(
                                          item.varName
                                        )
                                      },
                                      dblclick: function($event) {
                                        return _vm.toShowEditTplVarDialog(true)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(item.varName) +
                                        "\n                  "
                                    ),
                                    _c("i", {
                                      staticClass: "el-icon-circle-close del",
                                      on: {
                                        click: function($event) {
                                          return _vm.delTplVar(item)
                                        }
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          })
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("div", { staticClass: "bottom-field" }, [
            _c(
              "div",
              {
                staticStyle: {
                  height: "100%",
                  width: "1020px",
                  margin: "0 auto"
                }
              },
              [
                _c(
                  "el-button",
                  { attrs: { size: "mini" }, on: { click: _vm.gback } },
                  [_vm._v("取消")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.tplFrmSubmit }
                  },
                  [_vm._v("保存")]
                )
              ],
              1
            )
          ]),
          _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.editTplVarDialogName,
                visible: _vm.showEditTplVarDialog,
                width: "25%"
              },
              on: {
                "update:visible": function($event) {
                  _vm.showEditTplVarDialog = $event
                }
              }
            },
            [
              _c(
                "el-form",
                {
                  ref: "tplVarFrm",
                  staticClass: "val-form",
                  attrs: {
                    model: _vm.tplVarFrm,
                    rules: _vm.tplVarFrmRules,
                    size: "small"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "变量名称", prop: "varName" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.tplVarFrm.varName,
                          callback: function($$v) {
                            _vm.$set(_vm.tplVarFrm, "varName", $$v)
                          },
                          expression: "tplVarFrm.varName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "变量类型" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "select",
                          model: {
                            value: _vm.tplVarFrm.varType,
                            callback: function($$v) {
                              _vm.$set(_vm.tplVarFrm, "varType", $$v)
                            },
                            expression: "tplVarFrm.varType"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "文本", value: 0 }
                          }),
                          _c("el-option", {
                            attrs: { label: "数字", value: 1 }
                          }),
                          _c("el-option", {
                            attrs: { label: "日期", value: 2 }
                          }),
                          _c("el-option", {
                            attrs: { label: "手机号码", value: 3 }
                          }),
                          _c("el-option", {
                            attrs: { label: "身份证号码", value: 4 }
                          }),
                          _c("el-option", {
                            attrs: { label: "营业执照号", value: 5 }
                          }),
                          _c("el-option", {
                            attrs: { label: "统一社会编码格式", value: 6 }
                          }),
                          _c("el-option", {
                            attrs: { label: "电子邮箱", value: 7 }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("el-checkbox", {
                        attrs: { label: "是否必填" },
                        model: {
                          value: _vm.tplVarFrm.varIsMust,
                          callback: function($$v) {
                            _vm.$set(_vm.tplVarFrm, "varIsMust", $$v)
                          },
                          expression: "tplVarFrm.varIsMust"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "text-right" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini" },
                          on: {
                            click: function($event) {
                              _vm.showEditTplVarDialog = false
                            }
                          }
                        },
                        [_vm._v("取消")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger", size: "mini" },
                          on: { click: _vm.editTplVarSubmit }
                        },
                        [_vm._v("确定")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "选择授权范围",
                visible: _vm.visibleMoveOrg,
                top: "5vh",
                width: "50%"
              },
              on: {
                "update:visible": function($event) {
                  _vm.visibleMoveOrg = $event
                }
              }
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c(
                      "section",
                      [
                        _c(
                          "el-form",
                          {
                            staticStyle: {
                              "margin-top": "20px",
                              "text-align": "right"
                            },
                            attrs: {
                              inline: true,
                              size: "small",
                              model: _vm.filterModel
                            }
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "150px" },
                                  attrs: {
                                    placeholder: "邮箱/手机号",
                                    clearable: ""
                                  },
                                  model: {
                                    value: _vm.filterModel.targetId,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filterModel, "targetId", $$v)
                                    },
                                    expression: "filterModel.targetId"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "150px" },
                                  attrs: {
                                    placeholder: "签署方名称",
                                    clearable: ""
                                  },
                                  model: {
                                    value: _vm.filterModel.corpUserName,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.filterModel,
                                        "corpUserName",
                                        $$v
                                      )
                                    },
                                    expression: "filterModel.corpUserName"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "150px" },
                                    attrs: { placeholder: "请选择部门" },
                                    model: {
                                      value: _vm.filterModel.corpGroupId,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filterModel,
                                          "corpGroupId",
                                          $$v
                                        )
                                      },
                                      expression: "filterModel.corpGroupId"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "" }
                                    }),
                                    _vm._l(_vm.memberGroups, function(item, i) {
                                      return _c("el-option", {
                                        key: i,
                                        attrs: {
                                          label: item.groupName,
                                          value: item.corpGroupId
                                        }
                                      })
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { staticStyle: { "margin-right": "0px" } },
                              [
                                _c(
                                  "el-button",
                                  { on: { click: _vm.queryTool } },
                                  [_vm._v("查询")]
                                ),
                                _c(
                                  "el-button",
                                  { on: { click: _vm.approvalReset } },
                                  [_vm._v("重置")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          {
                            staticClass: "custom-table-style",
                            staticStyle: { padding: "0px" },
                            attrs: { span: 24 }
                          },
                          [
                            _c(
                              "el-table",
                              {
                                ref: "multipleTableRef",
                                staticStyle: {
                                  border: "1px solid #cbcbcb",
                                  "border-bottom": "0"
                                },
                                attrs: {
                                  data: _vm.tableSetManager,
                                  "tooltip-effect": "dark",
                                  "highlight-current-row": "",
                                  "cell-style": { cursor: "pointer" },
                                  "header-cell-style": {
                                    background: "#f9f9f9",
                                    color: "#333333",
                                    fontWeight: "500"
                                  }
                                },
                                on: {
                                  "selection-change": _vm.handleSelectionChange0
                                }
                              },
                              [
                                _c("el-table-column", {
                                  attrs: { type: "selection", width: "55" }
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: "邮箱/手机号",
                                    prop: "targetId",
                                    "show-overflow-tooltip": ""
                                  }
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: "名称",
                                    prop: "userName",
                                    "show-overflow-tooltip": ""
                                  }
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: "部门",
                                    prop: "groupNames",
                                    "show-overflow-tooltip": ""
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          {
                            staticClass: "page-flex-end",
                            staticStyle: {
                              padding: "30px 0",
                              position: "relative"
                            },
                            attrs: { span: 24 }
                          },
                          [
                            _c("el-pagination", {
                              attrs: {
                                "current-page": _vm.filterModel.itemPage,
                                "page-sizes": [10, 20, 50, 100],
                                "page-size": _vm.filterModel.pageSize,
                                layout: "sizes, prev, pager, next, total",
                                total: _vm.filterModel.pageTotal
                              },
                              on: {
                                "size-change": _vm.handleSizeChange,
                                "current-change": _vm.handleCurrentChange
                              }
                            }),
                            _c("el-go", {
                              attrs: {
                                "page-size": _vm.filterModel.pageSize,
                                total: _vm.filterModel.pageTotal
                              },
                              on: { "current-change": _vm.handleCurrentChange }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: {
                        click: function($event) {
                          _vm.visibleMoveOrg = false
                        }
                      }
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.handleSelectApprovalorOk()
                        }
                      }
                    },
                    [_vm._v("确 定")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d4393dfa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4393dfa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/console/authEdit.vue
// module id = w3zZ
// module chunks = 76